import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoadingController, ModalController, NavParams, Platform } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';
import { AuthService } from '@services/auth/auth.service';
import { EncryptService } from '@services/auth/encrypt.service';
import { AlertService } from '@services/utils/alerts/alert.service';
import { ValidationService } from '@services/utils/validations/validation.service';
import { first } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-update-password',
  templateUrl: './update-password.page.html',
  styleUrls: ['./update-password.page.scss']
})
export class UpdatePasswordPage implements OnInit {
  updatePasswordForm: FormGroup
  @Input() dataLogin: any

  errorsMessages: string[] = []
  submitted: boolean = false
  eyeImage: string[] = ['eye-off', 'eye-off', 'eye-off']
  typeInput: string[] = ['password', 'password', 'password']
  userData: any
  userInfo: any
  equalPasswords = false

  constructor(
    private authService: AuthService,
    public formBuilder: FormBuilder,
    public loadingController: LoadingController,
    public modalController: ModalController,
    public navParams: NavParams,
    private storage: Storage,
    private encryptService: EncryptService,
    private platform: Platform,
    private validationService: ValidationService,
    private alertService: AlertService,
    private router: Router
  ) {}

  ngOnInit() {
    this.userData = this.navParams.data.userData
    this.validateForm()
  }

  async changePassword() {
    this.submitted = true

    await this.alertService.presentLoading()

    this.authService
      .changePassword(this.getData())
      .pipe(first())
      .subscribe(
        (res) => {
          this.success(res)
        },
        (err) => {
          this.error()
        }
      )
  }

  getData() {
    let data = this.updatePasswordForm.controls
    this.userInfo = {
      id: this.userData.id,
      password: this.dataLogin.password.value,
      new_password: data.new_password.value,
      email: this.userData.email
    }
    return this.userInfo
  }

  success(res) {
    this.alertService.dismiss().then(() => {
      if (res.error) {
        this.alertService.statusAlert('Error!', 'Contraseña incorrecta')
      } else {
        this.alertService.statusAlert('Contraseña restaurada!', 'La contraseña ha sido cambiada exitosamente')
        if (this.platform.is('cordova') || this.platform.is('capacitor')) this.updatePasswordBiometric()
        this.modalController.dismiss()
        //IR A MENU
        this.router.navigate(['home'])
      }
    })
  }

  error() {
    this.alertService.dismiss().then(() => {
      this.alertService.statusAlert('Error!', 'Contraseña incorrecta')
    })
  }

  updatePasswordBiometric() {
    let data
    this.storage.get(environment.storageBiometric).then((val) => {
      if (val != null) {
        data = val
        data.password = this.encryptService.encrypt(this.userInfo.new_password)
        this.storage?.set(environment.storageBiometric, data)
      }
    })
  }

  validateForm() {
    this.updatePasswordForm = this.formBuilder.group(
      {
        new_password: [
          '',
          [Validators.compose([Validators.required]), this.validationService.Validation(6, 15, 'onlyPassword')]
        ],
        confirm_password: [
          '',
          [Validators.compose([Validators.required]), this.validationService.Validation(6, 15, 'onlyPassword')]
        ]
      },
      {
        validator: [this.confirmedValidator('new_password', 'confirm_password')]
      }
    )
  }

  private confirmedValidator(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName]
      const matchingControl = formGroup.controls[matchingControlName]
      if (matchingControl.errors && !matchingControl.errors.confirmedValidator) {
        return
      }
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ confirmedValidator: true })
      } else {
        matchingControl.setErrors(null)
      }
    }
  }

  changeImage(i: number) {
    if (this.eyeImage[i] == 'eye-off') {
      this.eyeImage[i] = 'eye'
      this.typeInput[i] = 'text'
      setTimeout(() => {
        this.eyeImage[i] = 'eye-off'
        this.typeInput[i] = 'password'
      }, 2000)
    } else {
      this.eyeImage[i] = 'eye-off'
      this.typeInput[i] = 'password'
    }
  }

  get errorControl() {
    return this.updatePasswordForm.controls
  }

  async closeModal() {
    await this.modalController.dismiss()
  }
}
